<ng-container *ngIf="showComponent">
  <div class="paragraph" *ngFor="let s of paragraph.sentences; trackBy: trackByFn">
    <app-sentence
      [sentence]="s"
      [thisItemPath]="childItemPaths[s.index]"
      [elId]="elId"
      [isActive]="activeSentenceIndex === s.index"
      [isHoverTarget]="hoverSentenceIndex === s.index"
    ></app-sentence>
  </div>
</ng-container>
